import React, { useState } from 'react';
import FormWrapper from '../common/FormGroup/FormWrapper';
import { IImageUploaderState, IImageUploaderImageData } from './DefaultState';
import FormTextInput from '../common/FormGroup/FormTextInput';
import FormImageUpload from '../common/FormGroup/FormImageUpload';
import FormSwitch from '../common/FormGroup/FormSwitch';

export interface IImageUploaderConfigurator {
    staticBlockState: IImageUploaderState;
    setStaticBlockState: (newStaticBlockState: IImageUploaderState) => void;
    imageUpload: (imgData: any) => any;
}

const ImageUploaderConfigurator = ({ staticBlockState, setStaticBlockState, imageUpload }: IImageUploaderConfigurator) => {
    const { settings, image } = staticBlockState;
    const { showBoxAround } = settings;
    const [isImageUploaded, setIsImageUploaded] = useState(false);

    const onSettingsChange = (key: string, value: boolean) => {
        setStaticBlockState({
            ...staticBlockState,
            settings: {
                ...staticBlockState.settings,
                [key]: value,
            },
        });
    };

    const onAltTextChange = (altText: string) => {
        setStaticBlockState({
            ...staticBlockState,
            image: {
                ...staticBlockState.image,
                altText: altText,
            },
        });
    };

    const onImageUploaded = ({ url, size, altText, type }: IImageUploaderImageData) => {
        console.log('here');
        setIsImageUploaded(true);
        setStaticBlockState({
            ...staticBlockState,
            image: {
                url,
                size,
                dateUploaded: new Date().toDateString(),
                altText,
                type,
            },
        });
    };

    return (
        <div className='ImageUploaderConfiguration'>
            <FormWrapper>
                <FormImageUpload imageUpload={imageUpload} onChange={onImageUploaded} altText={image.altText} imageUrl={image.url} />
                <div style={{ gridColumn: '1/6' }}>
                    {image && (
                        <small>
                            Size: {Math.round(image.size / 1024)} kB <br />
                            Type: {image.type} <br />
                        </small>
                    )}
                </div>
                {image && <FormTextInput label={'Alt Text'} value={image.altText} onChange={(altText: string) => onAltTextChange(altText)} />}
                {image && (
                    <FormSwitch
                        label={'Add image border'}
                        value={showBoxAround}
                        onChange={(showBoxAround: boolean) => onSettingsChange('showBoxAround', showBoxAround)}
                    />
                )}
            </FormWrapper>
        </div>
    );
};

export default ImageUploaderConfigurator;
